import PROFIL_ECRITURE from '../../../constants/mouvements/codeProfilEcritures';
import { MODE_REGLEMENT } from '../../../constants/mouvements/modeReglements';
import NATURE_PIECE from '../../../constants/mouvements/naturePiece';
import { TYPE_BORDEREAU } from '../../../constants/mouvements/typeBordereau';
import TYPE_PIECE from '../../../constants/mouvements/typePiece';
import CompteDeTiersPanel from '../panel/CompteDeTiersPanel';
import CovidPanel from '../panel/CovidPanel';
import ProjetPanel from '../panel/ProjetPanel';
import TravauxEnRegiePanel from '../panel/TravauxEnRegiePanel';
import BaseProfilEcritureDepense from './Base/BaseProfilEcritureDepense';

class ProfilEcritureRelevantPaieCollectifDepense extends BaseProfilEcritureDepense {
	constructor() {
		super();
		this.code = PROFIL_ECRITURE.DEPENSE.RELEVANT_PAIE_COLLECTIF;
		this.typeBordereau = TYPE_BORDEREAU.DEPENSE.ORDINAIRE;
		this.naturePiece = NATURE_PIECE.DEPENSE.PAIE;
		this.typePiece = TYPE_PIECE.DEPENSE.COLLECTIF;
		this.imputation.articles = ['621', '631', '633', '64'];
		this.modeDeReglement = [MODE_REGLEMENT.DEPENSE.VIREMENT_APP_EXTERNE];
		this.panels = [
			new CompteDeTiersPanel(),
			new CovidPanel(),
			new ProjetPanel(),
			new TravauxEnRegiePanel(),
		];
	}
}

export default ProfilEcritureRelevantPaieCollectifDepense;
